/**
 * 모바일 관리자(/ma) 사이트 부트스트랩 — 모든 /ma 페이지 진입 시 1회 실행
 * (app.js → loadSiteBootstrap('MobileAdmin')).
 * 하단탭 채팅 배지(관리자 미확인 방 수)를 진입 시 1회 받는다(폴링 없음 — 새 상담은 푸시로 온다).
 */
const api = {
    initialize() {
        $j.Sites = $j.Sites || {};
        $j.Sites.MobileAdmin = api;   // 페이지 모듈이 M.modal() 로 쓴다

        // ajax 401(세션 끊김)이면 로그인 화면으로 — /m 과 같은 처리($j.Common.Network.setupAjax).
        // 다른 기기에 밀려난 경우(앱 1대 로그인)가 대표다: 이게 없으면 /ma 는 화면마다 '세션이 만료되었습니다'
        // 토스트만 띄우고 그 자리에 머물러, 밀려난 줄도 모르고 버튼을 계속 누르게 된다.
        // Network.start() 를 통째로 켜지 않는 이유: 오프라인·느린망 배너의 CSS 가 m.css 에만 있다.
        $j.Common.Network.setupAjax();

        // 당겨서 새로고침 — /m 과 같은 모듈. /ma 도 document 가 스크롤러라(body 에 overflow 없음)
        // 그대로 동작한다. 상단 헤더는 position:sticky 라 그 위에서 시작한 당김은 무시된다.
        $j.Ui.PullRefresh.enable();

        // 바텀시트 — 슬롯 헤더 + 손잡이(/m·/b 와 같다). 끌어 닫기 판정은 기본값 그대로(looseDrag·stopAnywhere 끔) —
        // 회원·오더 편집 폼이 시트 안에 많아 완화하면 입력 중에 닫힌다.
        $j.Ui.BS.init({ header: 'slot', dragBar: true });

        // 불러톡 배지는 **페이지 진입 때 한 번만** 받는다.
        // 구: 30초 주기 폴링. 새 상담이 왔는지는 관리자에게 푸시로 오므로 폴링은 같은 사실을
        // 두 번 나르며 요청만 쌓았다. 화면을 옮기거나 당겨서 새로고침하면 어차피 다시 받는다.
        // (대화창 안의 실시간은 소켓이 맡는다 — $j.F.Chat)
        this.refreshBadge();

        // 하단탭 '전체' → 전체메뉴 서랍
        const menuBtn = document.getElementById('maNavMenu');
        if (menuBtn) menuBtn.onclick = () => this.openMenu();

        this.startSiteSwitch();
        this.defineUserWin();
        this.startApp();
    },

    /**
     * 앱(JB 웹뷰)으로서의 동작 — /m 과 **같은 흐름**을 부른다 ($j.F.JbApp).
     *
     * ⚠ 이걸 빼두면 초기페이지를 모바일관리자로 둔 CS 는 **앱이 아닌 것처럼 동작한다.**
     * 앱의 시작주소는 /m 이지만 그 CS 는 302 로 /ma 에 떨어져(HomeController::m) /m 의 JS 가
     * 한 번도 뜨지 않는다 — 푸시토큰·현위치 GPS·앱버전·푸시진단 스냅샷이 영영 안 쌓이고,
     * 알림음·TTS 설정도 폰에 안 실린다. 관리자도 불러톡 상담을 푸시로 받으므로 CS 업무가 먼저 깨진다.
     *
     * 남의 계정에 들어가 있는 동안(대리진입)은 $j.F.App.isApp() 이 통째로 막는다 —
     * 판정은 서버 is_admin_proxy() = G5.isAdminProxy (madmin tail.blade.php 가 심는다).
     * 그래서 여기에 따로 가드를 두지 않는다 (.ai/proxy-login.md §4-4).
     *
     * 회원 대상 게이트(위치동의 BS·공지/약관 전체팝업)는 부르지 않는다 — /ma 는 업무화면이고,
     * 회원에게 묻는 것은 회원화면에서 떠야 한다. 앱버전 게이트만 예외로 켠다: 구앱이면 브로커
     * 액션 자체가 안 먹어 /ma 업무도 함께 죽는다.
     */
    startApp() {
        $j.F.JbApp.start();                        // 디바이스 컨텍스트(토큰·GPS·모델·진단) 조회→저장 · 페이지코드 통보 · 2초 헬스체크
        if (!(typeof MEMBER !== 'undefined' && MEMBER && MEMBER.num > 0)) return;

        $j.F.App.clearHistoryOnFreshLogin();   // 웹뷰 history 초기화 (로그인 착지가 /ma 여도 백버튼이 로그인으로 가지 않게)
        $j.F.JbApp.syncMySettingsOncePerLogin();   // CS 본인 환경설정(푸시·TTS·알림음) → 네이티브. 로그인당 1회는 /m 과 같은 키로 센다
        $j.F.AppGate.start();                      // 앱버전 게이트 (지원하한 미만=강제 / 최신 미만=안내)
    },

    /**
     * '모바일' 전환 알약 — /m 으로 나가는 한 번 누르기 출구.
     *
     * 구: 하단탭 '전체' → 서랍 → '모바일 가기' 세 동작. CS 는 하루에도 수십 번 넘나드는데
     * 그 왕복이 곧 업무가 됐다. 반대편(/m → /ma)도 서랍 네 동작이라 같이 알약으로 바꿨다
     * ($j.F.Mobile.SiteSwitch). 모양·자리·끌어옮기기는 공용 $j.Ui.EdgeTab — 회원화면의
     * 복귀 알약과 같은 규격이라 CS 는 두 사이트에서 같은 자리를 누르게 된다.
     *
     * 이 알약이 생기면서 서랍의 '모바일 가기' 항목은 뺐다 — 같은 곳으로 가는 길을 둘 두면
     * 서랍이 '거기서만 되는 것'을 담는 자리라는 뜻을 잃는다. 알약은 전 화면에 상주하므로
     * 서랍을 여는 것보다 항상 가깝다.
     */
    startSiteSwitch() {
        if (document.getElementById('ma-site-switch')) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'ma-site-switch';
        btn.className = 'jb-edge-tab jb-edge-tab--member';
        btn.setAttribute('aria-label', '모바일(기사앱) 화면으로 이동 (끌어서 옮길 수 있음)');
        btn.innerHTML = '<i class="fas fa-mobile-screen" aria-hidden="true"></i><em>모바일</em>';
        document.body.appendChild(btn);

        // 저장키는 /m 쪽 알약과 나눈다 — 같은 기기라도 두 사이트에서 걸리는 것이 다르다.
        //
        // ⚠ 목적지가 '/m' 이 **아니라** 알림화면 주소다. '/m' 은 앱의 시작주소이고, 초기화면을
        //   모바일관리자로 둔 CS 에게는 서버가 그걸 /ma 로 되돌린다(HomeController::m).
        //   그대로 두면 이 알약을 눌러도 제자리라 기사앱에 발을 못 붙인다.
        //   '앱을 켰다'(/m)와 '기사앱을 보러 간다'(/m/alim)는 다른 뜻이다.
        $j.Ui.EdgeTab.attach(btn, { key: 'maSiteSwitch', onTap: () => location.replace('/m/alim') });
    },

    /**
     * 불러톡 대화창에서 **상대방(회원) 프로필을 누르면 그 회원 앱으로** 넘어간다.
     *
     * 공유 하네스($j.F.Chat)의 고객 아바타 클릭은 PC(/adm)에서만 기사관리 포털 별창을 연다
     * (F/Chat/Index.js — !isMobile 가드). 폰(/ma)에서는 별창이 무의미해 무동작이고,
     * 폰에서 제자리는 별창 대신 **대리진입**이다 — window.showUserWin 으로 그 경로를 세워 둔다.
     *
     * 돌아올 곳은 지금 보던 대화창 그대로다 — 복귀 알약을 누르면 하던 상담으로 되돌아온다.
     */
    defineUserWin() {
        if (typeof window.showUserWin === 'function') return;   // 이미 있으면(다른 사이트) 건드리지 않는다
        window.showUserWin = (mbNo) => {
            const n = parseInt(mbNo, 10) || 0;
            if (!n) return;
            const from = location.pathname + location.search;
            location.replace(`/ma/proxy/enter?mb_no=${n}`
                + `&returnurl=${encodeURIComponent('/m')}`
                + `&from=${encodeURIComponent(from)}`);
        };
    },

    /**
     * 전체메뉴 서랍 — 우→좌 슬라이드 사이드 드로어. 하단탭에 자리가 없는 화면이 모인다.
     * ('모바일 가기'는 옆구리 알약(startSiteSwitch)으로 옮겼다)
     *
     * 닫는 길을 세 개 둔다 — 안드로이드 **뒤로가기**, 패널 **하단 닫기바**, 상단 ✕/배경.
     * 폰을 한 손으로 쥔 CS 가 우상단 ✕ 까지 손가락을 올리는 게 이 화면에서 제일 잦은 불편이었다.
     * 뒤로가기는 히스토리 항목 하나(`{maDrawer:1}`)를 얹고 popstate 에서 닫는 방식.
     */
    openMenu() {
        this.closeMenu();
        const ITEMS = [
            { key: 'smsRecv', icon: 'fa-comment-dollar', label: '문자접수',  desc: '뱅킹SMS 확인·캐시충전' },
            { key: 'cash',    icon: 'fa-won-sign',      label: '입출금 관리', desc: '준비중', soon: true },
        ];
        const rows = ITEMS.map((it) =>
            '<button type="button" class="ma-menu-row' + (it.soon ? ' is-soon' : '') + '" data-menu="' + it.key + '">' +
            '  <span class="ma-menu-ic"><i class="fas ' + it.icon + '"></i></span>' +
            '  <span class="ma-menu-lb">' + it.label + '<em>' + (it.desc || '') + '</em></span>' +
            '  <i class="fas fa-chevron-right ma-menu-go"></i>' +
            '</button>').join('');

        const back = document.createElement('div');
        back.className = 'ma-drawer-back';
        back.innerHTML =
            '<aside class="ma-drawer" role="dialog" aria-label="전체메뉴">' +
            '  <div class="ma-drawer-hd"><h3>전체메뉴</h3>' +
            '    <button type="button" class="ma-drawer-x" aria-label="닫기"><i class="fas fa-times"></i></button></div>' +
            '  <div class="ma-drawer-bd"><div class="ma-menu">' + rows + '</div></div>' +
            '  <div class="ma-drawer-ft">' +
            '    <button type="button" class="ma-drawer-close"><i class="fas fa-chevron-down"></i>닫기</button>' +
            '  </div>' +
            '</aside>';
        document.body.appendChild(back);
        this._drawerEl = back;
        this._lockLayer(true);   // 가장자리 알약을 숨긴다 (알약 1070 이 서랍 1055 위로 뜬다)

        const close = () => this.closeMenu();
        back.querySelector('.ma-drawer-x').onclick = close;
        back.querySelector('.ma-drawer-close').onclick = close;
        back.addEventListener('click', (e) => { if (e.target === back) close(); });
        back.querySelectorAll('[data-menu]').forEach((b) => { b.onclick = () => this.onMenu(b.dataset.menu); });
        requestAnimationFrame(() => back.classList.add('is-open'));

        // 안드로이드 뒤로가기 = 닫기. 서랍 몫의 히스토리 항목을 하나 얹어두고 popstate 로 받는다
        // (이 항목은 닫을 때 반드시 되감는다 — 안 그러면 뒤로가기 한 번이 먹통이 된다)
        this._drawerHist = true;
        history.pushState({ maDrawer: 1 }, '', location.href);
        this._onPop = () => {
            if (history.state && history.state.maDrawer) return;
            this.closeMenu(true);
        };
        window.addEventListener('popstate', this._onPop);
    },

    /**
     * @param fromPop 뒤로가기(popstate)로 들어온 호출인가.
     *   true 면 히스토리는 이미 되감긴 상태라 back() 을 또 부르면 이전 페이지로 나가버린다.
     */
    closeMenu(fromPop) {
        if (this._onPop) { window.removeEventListener('popstate', this._onPop); this._onPop = null; }
        if (this._drawerEl) { this._drawerEl.remove(); this._drawerEl = null; }
        this._lockLayer(false);

        const hadHist = this._drawerHist;
        this._drawerHist = false;
        if (hadHist && !fromPop) history.back();   // 얹어둔 항목 회수
    },

    onMenu(key) {
        // 서랍이 얹은 히스토리 항목 위에서 replace → 그 항목이 이동 주소로 덮여 되감기가 깔끔하다
        if (key === 'smsRecv') { location.replace('/ma/sms-recv'); return; }
        if ($j.Ui && $j.Ui.Toast) $j.Ui.Toast.show('준비중입니다');
    },

    /**
     * 겹친 레이어(서랍·모달)가 열린 동안 body 에 표식을 남긴다 — 가장자리 알약을 CSS 로 숨긴다.
     * (shared/components/_edge-tab.scss 의 body.ma-layer-open)
     * 모달이 서랍 위에 겹칠 수 있으므로 실제로 남아 있는 요소를 보고 끈다 — 닫히는 순서에
     * 상관없이 마지막 하나가 사라질 때만 풀린다.
     */
    _lockLayer(on) {
        const stillOpen = !!(this._drawerEl || this._modalEl);
        document.body.classList.toggle('ma-layer-open', on || stillOpen);
    },

    refreshBadge() {
        $.getJSON('/ma/ajax/chat/badge')
            .done((r) => {
                const n = (r && +r.cnt) || 0;
                const $b = $('#maChatBadge');
                if (!$b.length) return;
                $b.text(n > 99 ? '99+' : n).prop('hidden', n <= 0);
            })
            .fail(() => {});
    },

    /**
     * 자체 모달 — BS(바텀시트) 위에 겹쳐 뜨는 액션/입력 모달.
     * ($j.Ui.Modal 계열은 CSS 출처가 얽혀 있어, /ma 는 자립 모달을 쓴다. z-index 로 BS 위에 스택)
     *
     * @param opts.title     헤더 제목
     * @param opts.bodyHtml  본문 HTML (입력폼 등)
     * @param opts.okLabel   확인 버튼 라벨
     * @param opts.okCls     확인 버튼 클래스(primary|danger)
     * @param opts.onOk      (bodyEl, close) => void  확인 클릭 시. 성공 시 close() 를 직접 호출.
     * @returns {{close:Function, bodyEl:HTMLElement}}
     *
     * 뒤로가기: BS 와 같은 방식으로 히스토리 항목을 얹는다. BS 보다 **나중에** 열리므로
     * 항목도 위에 쌓이고, 뒤로가기는 모달 → 시트 → 페이지 순으로 한 겹씩 닫힌다.
     */
    modal(opts = {}) {
        // 모달 위에 모달을 갈아끼우는 경우(예: 확인 → 입력) 히스토리 항목은 물려받는다.
        // closeModal() 을 그냥 부르면 back() 이 비동기로 돌면서 방금 연 모달을 닫아버린다.
        const stacked = !!this._modalEl;
        if (stacked) { this._offModalPop(); this._modalEl.remove(); this._modalEl = null; }
        else this.closeModal();

        const back = document.createElement('div');
        back.className = 'ma-modal-back';
        back.innerHTML =
            '<div class="ma-modal" role="dialog">' +
            '  <div class="ma-modal-hd"><h3>' + (opts.title || '') + '</h3>' +
            '    <button type="button" class="ma-modal-x" aria-label="닫기"><i class="fas fa-times"></i></button></div>' +
            '  <div class="ma-modal-bd">' + (opts.bodyHtml || '') + '</div>' +
            '  <div class="ma-modal-ft">' +
            // 읽기만 하는 창(내역 등)은 확인 버튼이 할 일이 없다 → 닫기 하나만 남긴다
            '    <button type="button" class="ma-modal-cancel">' + (opts.hideOk ? '닫기' : '취소') + '</button>' +
            (opts.hideOk ? '' :
            '    <button type="button" class="ma-modal-ok ' + (opts.okCls || 'primary') + '">' + (opts.okLabel || '확인') + '</button>') +
            '  </div>' +
            '</div>';
        document.body.appendChild(back);
        this._modalEl = back;
        this._lockLayer(true);

        this._pushModalHistory();   // 뒤로가기 = 모달 닫기 (BS 위에 얹히므로 항목도 BS 것 위에 쌓인다)

        const bodyEl = back.querySelector('.ma-modal-bd');
        const close = () => this.closeModal();
        back.querySelector('.ma-modal-x').onclick = close;
        back.querySelector('.ma-modal-cancel').onclick = close;
        back.addEventListener('click', (e) => { if (e.target === back) close(); });
        const okBtn = back.querySelector('.ma-modal-ok');
        if (okBtn) okBtn.onclick = () => {
            if (typeof opts.onOk === 'function') opts.onOk(bodyEl, close);
            else close();
        };
        requestAnimationFrame(() => back.classList.add('is-open'));

        const input = bodyEl.querySelector('input, textarea, select');
        if (input) setTimeout(() => { try { input.focus(); } catch (_) {} }, 50);

        return { close, bodyEl };
    },

    /** 뒤로가기 몫의 항목을 얹고 popstate 를 듣는다. 이미 얹어둔 상태면 리스너만 다시 건다 */
    _pushModalHistory() {
        if (!this._modalHist) {
            this._modalHist = true;
            history.pushState({ maModal: 1 }, '', location.href);
        }
        this._offModalPop();
        // 내 항목이 실제로 빠졌을 때만 닫는다 (BS 와 같은 규약 — 겹친 레이어끼리 서로 닫지 않게)
        this._onModalPop = () => {
            if (history.state && history.state.maModal) return;
            this.closeModal(true);
        };
        window.addEventListener('popstate', this._onModalPop);
    },

    _offModalPop() {
        if (!this._onModalPop) return;
        window.removeEventListener('popstate', this._onModalPop);
        this._onModalPop = null;
    },

    /** @param fromPop 뒤로가기로 들어온 호출인가 (closeMenu 와 같은 규약) */
    closeModal(fromPop) {
        this._offModalPop();
        if (this._modalEl) { this._modalEl.remove(); this._modalEl = null; }
        this._lockLayer(false);

        const hadHist = this._modalHist;
        this._modalHist = false;
        if (hadHist && !fromPop) history.back();   // 얹어둔 항목 회수
    },
};

export default api;
